export const Props = () => ({
  //----------------------------------------------------------------------------
  //                         Массив с 'хлебными крошками'
  //----------------------------------------------------------------------------
  breadcrumbs: {
    type: Array,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});